// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__28eb4","errors":"Errors_errors__3F2BR"};